import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiAlertCircle, FiHome } from 'react-icons/fi';

interface UnauthorizedPageProps {
  message?: string;
}

export const UnauthorizedPage: React.FC<UnauthorizedPageProps> = ({ 
  message = "You don't have permission to access this page" 
}) => {
  const navigate = useNavigate();

  return (
    <div className="h-screen w-screen bg-[#f7faf8] flex items-center justify-center">
      <div className="text-center px-6">
        {/* Icon */}
        <div className="mb-6 flex justify-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-red-50 border-2 border-red-200">
            <FiAlertCircle className="h-10 w-10 text-red-500" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-slate-800 mb-3">
          Access Denied
        </h1>

        {/* Message */}
        <p className="text-slate-600 text-base mb-8 max-w-md mx-auto">
          {message}
        </p>

        {/* Actions */}
        <div className="flex gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-2.5 rounded-md border border-slate-300 text-slate-700 text-sm font-semibold hover:bg-slate-50 transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={() => navigate('/app')}
            className="px-6 py-2.5 rounded-md bg-[#0A6AAC] text-white text-sm font-semibold hover:bg-[#085489] transition-colors flex items-center gap-2"
          >
            <FiHome size={16} />
            Go to Home
          </button>
        </div>

        {/* Help text */}
        <p className="mt-8 text-xs text-slate-500">
          If you believe you should have access, please contact your administrator.
        </p>
      </div>
    </div>
  );
};

